import { render, staticRenderFns } from "./MatrixList.vue?vue&type=template&id=44cc1a24&scoped=true&"
import script from "./MatrixList.vue?vue&type=script&lang=js&"
export * from "./MatrixList.vue?vue&type=script&lang=js&"
import style0 from "./MatrixList.vue?vue&type=style&index=0&id=44cc1a24&prod&lang=scss&scoped=true&"
import style1 from "./MatrixList.vue?vue&type=style&index=1&id=44cc1a24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cc1a24",
  null
  
)

export default component.exports